import React, { useEffect } from "react";
import SideBarBack from "../../components/SidebarBack";
import { useDispatch, useSelector } from "react-redux";
import {
  setDrawerActiveMenu,
  setIsDrawerActive,
} from "../../store/features/webUtilitiesSlice";
import secureLocalStorage from "react-secure-storage";

export default function ProfileInfo() {
  const { profileDetails } = useSelector((state) => state.webUtilities);
  const age_val = profileDetails?.surveyItems[4]?.categoryItems[0].isVal;
  const height_cm = profileDetails?.surveyItems[1]?.categoryItems[2].isVal;
  const height_ft = profileDetails?.surveyItems[1]?.categoryItems[0].isVal;
  const height_inch = profileDetails?.surveyItems[1]?.categoryItems[1].isVal;
  const dispatch = useDispatch();
  const handleChangeSidebar = async (menu) => {
    await dispatch(setDrawerActiveMenu(menu));
  };

  const handleCloseDrawer = async () => {
    if (secureLocalStorage.getItem("backMenu")) {
      await dispatch(setDrawerActiveMenu(3));
      secureLocalStorage.removeItem("backMenu");
    } else {
      await dispatch(setDrawerActiveMenu(null));
      await dispatch(setIsDrawerActive(false));
    }
  };

  useEffect(() => {}, []);

  return (
    <div className="w-full h-full">
      <div className="w-full flex mb-2">
        <SideBarBack handleCloseDrawer={handleCloseDrawer} />
        {/* <div className='maitit w-[85%]'>
          <p className='text-lg font-medium'>My Profile</p>
        </div> */}
      </div>

      <div className="bodylydes mt-5 mb-10">
        <div className="profilebase spacetop">
          <div className="centr  profileimagebox">
            <img
              src={`${profileDetails?.image}`}
              alt="profileimf"
              className="h-[111px] rounded-full"
            />
          </div>
        </div>
      </div>
      <div className="bodyly spwok pb-8 gap-6 flex flex-col justify-between">
        <div className="profileinfo px-10">
          <div className="my-2 mb-5">
            <p className="text-xs font-semibold mb-0 leading-[0.4] text-capitalize">
              {profileDetails?.name}
            </p>
            <span className="text-[10px] font-medium text-[gray]">
              Full Name
            </span>
          </div>
          <div className="my-2 mb-5">
            <p className="text-xs font-semibold mb-0 leading-[0.4]">
              {profileDetails?.email}
            </p>
            <span className="text-[10px] font-medium text-[gray]">Email</span>
          </div>
          {profileDetails?.phone && (
            <div className="my-2 mb-5">
              <p className="text-xs font-semibold mb-0 leading-[0.4]">
                {profileDetails?.phone}
              </p>
              <span className="text-[10px] font-medium text-[gray]">
                Phone No.
              </span>
            </div>
          )}

          <div className="my-2 mb-5">
            <div className="flex justify-between">
              <div className="text-left">
                <p className="text-xs font-semibold mb-0 leading-[0.4]">
                  {age_val} yrs
                </p>
                <span className="text-[10px] font-medium text-[gray]">Age</span>
              </div>
              <div className="text-right">
                <p className="text-xs font-semibold mb-0 leading-[0.4]">
                  {height_cm
                    ? height_cm + "cm"
                    : height_ft + "ft " + height_inch + " inch"}
                </p>
                <span className="text-[10px] font-medium text-[gray]">
                  Height
                </span>
              </div>
            </div>
          </div>
          <div className="my-2 mb-5">
            <div className="flex justify-between">
              <div className="text-left">
                <p className="text-xs font-semibold mb-0 leading-[0.4]">
                  {profileDetails?.summary?.currentWeight} kg
                </p>
                <span className="text-[10px] font-medium text-[gray]">
                  Registered weight
                </span>
              </div>
              <div className="text-right">
                <p className="text-xs font-semibold mb-0 leading-[0.4]">
                  {profileDetails?.summary?.targetWeight} kg
                </p>
                <span className="text-[10px] font-medium text-[gray]">
                  Target weight
                </span>
              </div>
            </div>
          </div>
          {/* <div className="my-2 mb-5">
            <p className="text-xs font-semibold mb-0 leading-[0.4]">Vacation</p>
            <span className="text-[10px] font-medium text-[gray]">
              Specific goal
            </span>
          </div>
          <div className="my-2 mb-5">
            <p className="text-xs font-semibold mb-0 leading-[0.4]">
              25 Nov 2023
            </p>
            <span className="text-[10px] font-medium text-[gray]">
              Goal date
            </span>
          </div> */}
        </div>
        <div
          onClick={() => handleChangeSidebar(2)}
          className="text-center w-full cursor-pointer"
        >
          <div className="text-lg font-medium border rounded py-2">
            Edit profile →
          </div>
        </div>
      </div>
    </div>
  );
}
